<template>
    <div class="items-center w-full grid grid-cols-6 text-gray-700 h-16 ">
        <jet-label
            class=" text-white whitespace-nowrap col-span-6 z-11 text-base"
            :value="'Intervalo de ' + config.text"
        />
        <div
            class="flex w-full items-center col-span-6 border border-solid border-black rounded-md px-2 pt-2 h-10"
        >
            <div class="-mt-2  fill-current mr-4 z-10 ">
                De:
            </div>
            <div class="-mt-2  fill-current w-full z-10">
                <input
                    id="n_inicial"
                    type="text"
                    clear-button-icon="fa fa-times"
                    v-money="
                        !config.isPrecision
                            ? null
                            : selectedNumberMoneyRange.from
                    "
                    v-model="selectedNumberRange.from"
                    class="w-full focus:outline-none text-left bg-transparent  "
                    autocomplete="off"
                    @input="sendForm"
                />
            </div>
            <span class="-mt-2 mx-4">|</span>
            <div class="-mt-2  fill-current mr-4 z-10">
                Até:
            </div>
            <div class=" -mt-2 fill-current w-full pr-5 z-10">
                <input
                    id="n_final"
                    type="text"
                    clear-button-icon="fa fa-times"
                    v-money="
                        !config.isPrecision ? null : selectedNumberMoneyRange.to
                    "
                    v-model="selectedNumberRange.to"
                    class="w-full py-2 focus:outline-none text-left  bg-transparent"
                    autocomplete="off"
                    @input="sendForm"
                />
            </div>
        </div>
    </div>
</template>
<script>
import JetLabel from "../../Jetstream/Label.vue";

export default {
    props: {
        config: { type: Object, required: true },
        selectedNumberMoneyRange: { type: Object, default: () => ({}) },
        selectedNumberRange: { type: Object, default: () => ({}) }
    },
    methods: {
        parseCurrency(value) {
            return value
                ? parseFloat(
                      value
                          .split(".")
                          .join("")
                          .split(",")
                          .join(".")
                  )
                : null;
        },
        sendForm() {
            if(
                this.parseCurrency(this.selectedNumberRange.from) === 0 &&
                this.parseCurrency(this.selectedNumberRange.to) === 0
            ){
                this.$emit("input", {
                    number_field: this.config.key,
                    number_from: null,
                    number_to: null,
                });
            }
            if (
                this.parseCurrency(this.selectedNumberRange.from) ||
                this.parseCurrency(this.selectedNumberRange.to)
            ) {
                this.$emit("input", {
                    number_field: this.config.key,
                    number_from: this.parseCurrency(
                        this.selectedNumberRange.from
                    ),
                    number_to: this.parseCurrency(this.selectedNumberRange.to),
                    isPrecision: this.config.isPrecision
                });
            }
        }
    },
    watch: {
        '$page.props.queryString'(){
            const query = this.$page.props?.queryString
            for (let key in query) {
                if (!query[key]?.number_from && !query[key]?.number_to) {
                    this.date = {
                        to: '',
                        from: ''
                    }
                    break;
                }
            }
        }
    },
    components: {
        JetLabel
    }
};
</script>
